// Kept in its own module, deliberately free of imports.
//
// This used to live in api.js, which meant importing it pulled in ./auth ->
// ../config/msal, and msal.js reads window.location.origin at module scope.
// Under vitest's "node" environment that threw "window is not defined" before a
// single assertion ran, so the whole apiErrorMessage suite silently never
// executed. A pure formatting helper should not drag an auth bootstrap behind
// it — hence the split. api.js re-exports it so callers are unaffected.

const FRIENDLY_CODE_MESSAGES = {
  NO_AUTH0_IDENTITY:
    "No online account exists for that email. Confirm the member has registered online and that the email is spelled correctly.",
  ASSOCIATION_DETAILS_NOT_FOUND:
    "Membership number not found. Double-check the membership number and try again.",
};

// Turn any axios error into a human-readable string for the UI.
export function apiErrorMessage(error, fallback) {
  const data = error?.response?.data;
  const code = data && (data._error || (data.errors && data.errors._error));
  if (code && FRIENDLY_CODE_MESSAGES[code]) return FRIENDLY_CODE_MESSAGES[code];
  if (data && data.message) return data.message;
  if (typeof data === "string" && data) return data;
  if (fallback) return fallback;
  if (error?.message) {
    return `Request failed: ${error.message}. Check connection/VPN and try again.`;
  }
  return "Request failed. Check connection/VPN and try again.";
}

// Some endpoints are called with `validateStatus: () => true`, so a failure
// arrives as a normal response instead of a thrown error. Wrap it so the same
// friendly-message logic applies to both paths.
export function responseErrorMessage(response, fallback) {
  return apiErrorMessage({ response }, fallback);
}
